import script from "./Info.vue?vue&type=script&lang=ts&setup=true"
export * from "./Info.vue?vue&type=script&lang=ts&setup=true"

import "./Info.vue?vue&type=style&index=0&id=475c87a3&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475c87a3"]])

export default __exports__